import { createSelector } from 'reselect'
import { IStore } from '../../reducers/index'
import settingsEnums from '../../../helpers/enums/settings'
import settingsHelper from '../../../helpers/utils/settings'

const audioSelector = (state: IStore) => state.app.audio
const configSelector = (state: IStore) => state.app.config
const settingsSelector = (state: IStore) => state.game.settings
const isTeacherSelector = (state: IStore) => state.app.isTeacher

export default createSelector(
	audioSelector,
	configSelector,
	settingsSelector,
	isTeacherSelector,
	(audio, config, settings, isTeacher) => {
		const audioSetting = settingsHelper.getSettingValue(settings, settingsEnums.SETTING_TYPE_AUDIO)

		const defaultMuted = !isTeacher
				? audioSetting === settingsEnums.SETTING_GAME_AUDIO_MUTED
				: false
		const isMuted = audio.isMuted || defaultMuted
		return {
			isMuted,
			volume: audio.volume,
			path: config.assets_path || '/',
		}
	}
)
